var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "complain text-left"
  }, [_c('p', {
    staticClass: "text-2xl font-bold mb-6 text-neutral-700"
  }, [_vm._v("Ajukan Komplain")]), _c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "borderEnabled": "",
      "type": "text",
      "label": "Nama Lengkap",
      "placeholder": "Masukan nama lengkap",
      "error": _vm.errors['name']
    },
    model: {
      value: _vm.payloads.name,
      callback: function callback($$v) {
        _vm.$set(_vm.payloads, "name", $$v);
      },
      expression: "payloads.name"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "borderEnabled": "",
      "type": "text",
      "label": "Alamat Email",
      "placeholder": "Masukan alamat email",
      "error": _vm.errors['email']
    },
    model: {
      value: _vm.payloads.email,
      callback: function callback($$v) {
        _vm.$set(_vm.payloads, "email", $$v);
      },
      expression: "payloads.email"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "borderEnabled": "",
      "type": "number",
      "label": "No. Handphone",
      "placeholder": "Masukan nomor handphone",
      "error": _vm.errors['phone_number']
    },
    model: {
      value: _vm.payloads.phone_number,
      callback: function callback($$v) {
        _vm.$set(_vm.payloads, "phone_number", $$v);
      },
      expression: "payloads.phone_number"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('Textarea', {
    attrs: {
      "borderEnabled": "",
      "label": "Keluhan",
      "placeholder": "Masukan keluhan",
      "error": _vm.errors['comment']
    },
    model: {
      value: _vm.payloads.comment,
      callback: function callback($$v) {
        _vm.$set(_vm.payloads, "comment", $$v);
      },
      expression: "payloads.comment"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-3 inline-block"
  }, [_vm._v("Upload Photo (optional)")]), _c('div', {
    staticClass: "flex items-start gap-3"
  }, [_c('div', {
    staticClass: "upload-image-1"
  }, [!_vm.images.proof_url_1 ? _c('div', {
    staticClass: "w-20 h-20"
  }, [_c('label', {
    staticClass: "text-primary-500 bg-neutral-200 flex justify-center items-center w-full h-full cursor-pointer",
    attrs: {
      "for": "proof-image-1"
    }
  }, [_c('Upload')], 1), _c('input', {
    staticClass: "absolute -z-1 opacity-0",
    attrs: {
      "type": "file",
      "id": "proof-image-1",
      "accept": ".jpg, .png, .jpeg"
    },
    on: {
      "change": function change($event) {
        return _vm.handleFileSelect($event, 'complain', 'proof_url_1');
      }
    }
  })]) : _c('div', {
    staticClass: "w-40"
  }, [_c('img', {
    attrs: {
      "src": _vm.images.proof_url_1
    }
  })])]), _c('div', {
    staticClass: "upload-image-2"
  }, [!_vm.images.proof_url_2 ? _c('div', {
    staticClass: "w-20 h-20"
  }, [_c('label', {
    staticClass: "text-primary-500 bg-neutral-200 flex justify-center items-center w-full h-full cursor-pointer",
    attrs: {
      "for": "proof-image-2"
    }
  }, [_c('Upload')], 1), _c('input', {
    staticClass: "absolute -z-1 opacity-0",
    attrs: {
      "type": "file",
      "id": "proof-image-2",
      "accept": ".jpg, .png, .jpeg"
    },
    on: {
      "change": function change($event) {
        return _vm.handleFileSelect($event, 'complain', 'proof_url_2');
      }
    }
  })]) : _c('div', {
    staticClass: "w-40"
  }, [_c('img', {
    attrs: {
      "src": _vm.images.proof_url_2
    }
  })])])])]), _c('div', {
    staticClass: "mb-6 flex items-center gap-4 w-full"
  }, [_c('div', {
    staticClass: "text-sm w-full p-4 flex items-center gap-3 bg-secondary-100 text-neutral-700 rounded-md"
  }, [_c('span', {
    staticClass: "flex-shrink-0"
  }, [_c('Info', {
    attrs: {
      "width": "24",
      "height": "24",
      "color": "neutral-700"
    }
  })], 1), _vm._v(" LinkNau adalah layanan pihak ke-3, kami akan membantu menyampaikan keluhan terkait kendala paket kiriman. Pihak logistik akan menghubungi pegirimin via email ataupun telepon. ")])]), _c('div', {
    staticClass: "flex justify-end gap-4 mb-2"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Batal",
      "type": "secondary",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function action($event) {
        return _vm.closeModal();
      }
    }
  }), _c('Button', {
    attrs: {
      "buttonText": "Kirim",
      "type": "primary",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function action($event) {
        return _vm.submit();
      }
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }